"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const R = __importStar(require("ramda"));
const isEmpty = R.anyPass([R.isEmpty, R.isNil]);
exports.isEmptyAddress = R.anyPass([
    isEmpty,
    R.allPass([
        R.propSatisfies(isEmpty, 'street1'),
        R.propSatisfies(isEmpty, 'street2'),
        R.propSatisfies(isEmpty, 'zip'),
        R.propSatisfies(isEmpty, 'city'),
        R.propSatisfies(isEmpty, 'state'),
        R.propSatisfies(isEmpty, 'country'),
    ]),
]);
//# sourceMappingURL=isEmptyAddress.js.map